<template>
  <div class="yh-page">
    <el-card v-loading="loading" :element-loading-text="loadingText">
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="14">
          <span>
            <el-button v-if="showAdd" type="primary" size="small" icon="el-icon-plus" @click="handleDetailCreate">添加到账</el-button>
          </span>
          &nbsp;
          <template v-if="is_completed && showConfirm">
          <span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleConfirm">完成到账确认</el-button>
          </span>
          &nbsp;
          </template>
          <span>
            <el-button type="primary" size="small" icon="el-icon-back" @click="() => {this.$router.go(-1)}">返回</el-button>
          </span>
        </el-col>
      </el-row>

      <el-collapse v-model="activeNames">
        <el-collapse-item title="账务概况" name="1">
          <table>
            <tr>
              <th width="100px">业务数</th>
              <th width="150px">应收金额</th>
              <th width="150px">实收金额</th>
              <th width="150px">未收金额</th>
              <th width="150px">抵扣金额</th>
            </tr>
            <tr>
              <td>{{ apply_list.length }} 笔</td>
              <td>{{ receivable_amount }} 元</td>
              <td>{{ received_amount }} 元</td>
              <td>{{ unreceived_amount }} 元</td>
              <td>{{ deduction_amount }} 元</td>
            </tr>
          </table>
        </el-collapse-item>
        <el-collapse-item title="到账明细" name="2">
          <!-- 账单文件列表 -->
          <el-table :key="0" :data="insurance_finance_detail_list" stripe v-loading="detail_loading" :element-loading-text="loadingText"
                    fit highlight-current-row class="w-100">
            <!-- id -->
            <el-table-column align="left" label="id" width="50">
              <template slot-scope="scope">
                <span v-if="showView"
                  >{{scope.row.id}}</span>
              </template>
            </el-table-column>

            <!-- 收款账户 -->
            <el-table-column align="left" label="收款账户">
              <template slot-scope="scope">
                <span  v-if="showView"
                  >{{ scope.row.received_account}}</span>
              </template>
            </el-table-column>

            <!-- 收款金额 -->
            <el-table-column align="left" label="收款金额" width="120px">
              <template slot-scope="scope">
                <span>{{ scope.row.account| parsecurrency}}</span>
              </template>
            </el-table-column>

            <!-- 收款日期 -->
            <el-table-column align="left" label="收款日期" width="120px">
              <template slot-scope="scope">
                <span>{{ scope.row.received_date | parseTime('{y}-{m}-{d}') }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.remark}}</span>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column align="left" label="操作" width="150px">
              <template slot-scope="scope">

                <el-tooltip effect="light" placement="top-start" content="编辑">
                  <el-button v-if="showEdit" type="text"
                    @click="handleUpdate(scope.row.id, showDialogSave)" >
                    <i class="el-icon-edit"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="删除">
                  <el-button v-if="showDelete" type="text"
                    @click="handleDelete(scope.row.id)" >
                    <i class="el-icon-delete"></i>
                  </el-button>
                </el-tooltip>

              </template>
            </el-table-column>

          </el-table>
          <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
        </el-collapse-item>
        <el-collapse-item title="业务清单" name="3">
          <el-row>
            <table>
              <tr>
                <th width="100px">已勾选金额</th>
                <th width="100px">保费</th>
                <th width="100px">风险准备金</th>
                <th width="100px">合计</th>
              </tr>
              <tr>
                <td>原额</td>
                <td>{{ check_insurance_premium }} 元</td>
                <td>{{ check_risk_premium }} 元</td>
              </tr>
              <tr>
                <td>抵扣</td>
                <td>{{ check_deduction_insurance_premium }} 元</td>
                <td>{{ check_deduction_risk_premium }} 元</td>
              </tr>
              <tr>
                <td>合计</td>
                <td>{{ check_total_insurance_premium }} 元</td>
                <td>{{ check_total_risk_premium }} 元</td>
                <td>{{ check_total_premium }} 元</td>
              </tr>
            </table>
          </el-row>
          <!-- <el-row>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">选中全部未到账清单</el-checkbox>
          </el-row>
          <el-checkbox-group v-model="checkList" @change="handleCheckListChange"> -->
            <el-table border show-summary :data="apply_list" highlight-current-row @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
              <!-- <el-table-column align="left" label="选择" width="80px">
                <template slot-scope="scope">
                  <el-checkbox :label="scope.row" :disabled="scope.row.finance_detail !== null" :checked="isCheck(scope.row)">&nbsp;</el-checkbox>
                </template>
              </el-table-column> -->
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column prop="customer_name" label="会员名称"></el-table-column>
              <el-table-column prop="ship_name" label="船名"></el-table-column>
              <el-table-column prop="pay_gross_ton" label="船舶总吨"></el-table-column>
              <el-table-column prop="big_premium" label="大桥险保费(元)"></el-table-column>
              <el-table-column prop="risk_premium" label="本期风险准备金(元)"></el-table-column>
              <el-table-column prop="small_premium" label="小桥险保费(元)"></el-table-column>
              <el-table-column prop="dues" label="入会会费(元)"></el-table-column>
              <el-table-column prop="deduction_risk_premium" label="抵扣风险准备金"></el-table-column>
              <el-table-column prop="deduction_insurance_premium" label="抵扣保费"></el-table-column>
              <el-table-column prop="total_amount" label="合计费用(元)"></el-table-column>
              <!-- 是否支付 -->
              <!-- <el-table-column align="left" label="支付状态" width="120px">
                <template slot-scope="scope">
                  <el-tag size="small" :type="scope.row.finance_detail === null ? 'warning' : 'success'">
                    {{ scope.row.finance_detail === null ? '未到账' : '已到账'}}
                  </el-tag>
                </template>
              </el-table-column> -->
            </el-table>
          <!-- </el-checkbox-group> -->
        </el-collapse-item>
      </el-collapse>
    </el-card>
    <finance-detail-dialog ref="detail"
      :finance_id="insurance_finance_id"
      :receivable_amount="receivable_amount"
      :received_amount="received_amount"
      :unreceived_amount="unreceived_amount"
      :deduction_amount="deduction_amount"
      @updateList="loadData"
    >
    </finance-detail-dialog>
  </div>
</template>

<script>
import { fetchInsuranceFinanceApplys, fetchInsuranceFinanceDetails, deleteInsuranceFinanceDetail, confirmFinance } from '@/api/group-insurance'
import FinanceDetailDialog from './finance-detail-dialog'
import { formatCurrency } from '@/utils/misc'
import Pagination from '@/components/Pagination'
import { EventBus } from "@/utils/event-bus"
export default {
  components: {
    Pagination,
    FinanceDetailDialog,
  },
  data() {
    return {
      loading: false,
      from_type:'',
      detail_loading: false,
      loadingText: '正在加载数据，请稍等...',
      insurance_finance_id: '',
      activeNames: ["1", "2", "3"],
      apply_list: [],
      insurance_finance_detail_list: [],
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      showConfirm: false,
      showDialogSave: true,
      query:{
        search: '',
        limit: 10,
        offset: 0,
      },
      total: 0,
      checkList: [],
      isIndeterminate: true,
      checkAll: false,
      currentRow: null,
      multipleSelection: [],
      check_insurance_premium: 0,
      check_risk_premium: 0,
      check_deduction_insurance_premium: 0,
      check_deduction_risk_premium: 0,
      check_total_insurance_premium: 0,
      check_total_risk_premium: 0,
      check_total_premium: 0,
    }
  },
  computed: {
    received_amount: function() {
      let result = 0.0
      for (let l of this.insurance_finance_detail_list) {
        result = result + parseFloat(l.account)
      }
      return parseFloat(result.toFixed(4))
    },
    receivable_amount() {
      let amount = 0
      if (this.apply_list.length > 0) {
        this.apply_list.forEach(a => {
          amount += parseFloat(a.total_amount)
        })
      }
      return parseFloat(amount.toFixed(4))
    },
    deduction_amount(){
      let result = 0.0
      if (this.apply_list.length > 0) {
        this.apply_list.forEach(a => {

          result += ( parseFloat(a.deduction_risk_premium) + parseFloat(a.deduction_insurance_premium))
        })
      }
      return parseFloat(result.toFixed(4))
    },
    unreceived_amount() {
      let result = 0.0
      result = this.receivable_amount - this.received_amount - this.deduction_amount
      return parseFloat(result.toFixed(4))
    },
    is_completed: function() {
      let result = false
      if (parseFloat(this.unreceived_amount) >= -1 && parseFloat(this.unreceived_amount) <= 1.0){
        result = true
      }
      return result
    },
    is_diff() {
      let result = false
      if (this.received_amount.toFixed(4) != (this.receivable_amount - this.deduction_amount).toFixed(4)){
        result = true
      }
      return result
    },
    // check_amount() {
    //   let amount = 0
    //   if (this.checkList.length !== 0) {
    //     this.checkList.forEach(item => {
    //       amount += item.total_amount
    //     })
    //   }
    //   return amount.toFixed(4)
    // }
  },
  filters: {
    parsecurrency: function(value){
      return formatCurrency(value, 2)
    },
  },
  methods: {
    loadData() {
      this.checkList = []
      this.loading = true
      let p =[]
      p.push(fetchInsuranceFinanceApplys(this.insurance_finance_id))
      p.push(fetchInsuranceFinanceDetails(this.insurance_finance_id, this.query))
      Promise.all(p).then(res => {
        this.loading = false
        this.apply_list = res[0].apply_list
        this.insurance_finance_detail_list = res[1].results
        this.total = res[1].count
        if (res[0].is_account){
          this.showAdd = false
          this.showConfirm = false
          // this.showEdit = false
          this.showDelete = false
          this.showDialogSave = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    getList() {
      this.detail_loading = true
      fetchInsuranceFinanceDetails(this.insurance_finance_id, this.query).then(res => {
        this.insurance_finance_detail_list = res.results
        this.total = res.count
        this.detail_loading = false
      }).catch(err => {
        this.detail_loading = false
        this.$message.error(err)
      })
    },
    // isCheck(row) {
    //   let is_check = false
    //   for (var i = 0; i < this.checkList.length; i++) {
    //     if (this.checkList[i].id === row.id) {
    //       is_check = true
    //       break;
    //     }
    //   }
    //   return is_check
    // },
    // handleCheckAllChange(val) {
    //   this.checkList = val ? this.apply_list.filter(item => item.finance_detail === null) : [];
    //   this.isIndeterminate = false;
    // },
    // handleCheckListChange(value) {
    //   let checkedCount = value.length;
    //   let no_finance_detail_apply_list = this.apply_list.filter(item => item.finance_detail === null)
    //   this.checkAll = checkedCount === no_finance_detail_apply_list.length;
    //   this.isIndeterminate = checkedCount > 0 && checkedCount < no_finance_detail_apply_list.length;
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let check_insurance_premium = 0,
      check_risk_premium = 0,
      check_deduction_insurance_premium = 0,
      check_deduction_risk_premium = 0,
      check_total_insurance_premium = 0,
      check_total_risk_premium = 0
      if (val.length > 0) {
        val.forEach(item => {
          check_insurance_premium += parseFloat(item.big_premium) + parseFloat(item.small_premium)
          check_risk_premium += parseFloat(item.risk_premium)
          check_deduction_insurance_premium += parseFloat(item.deduction_insurance_premium)
          check_deduction_risk_premium += parseFloat(item.deduction_risk_premium)
        })
        check_total_insurance_premium = check_insurance_premium - check_deduction_insurance_premium
        check_total_risk_premium = check_risk_premium - check_deduction_risk_premium
      }
      this.check_insurance_premium = parseFloat(check_insurance_premium.toFixed(4))
      this.check_risk_premium = parseFloat(check_risk_premium.toFixed(4))
      this.check_deduction_insurance_premium = parseFloat(check_deduction_insurance_premium.toFixed(4))
      this.check_deduction_risk_premium = parseFloat(check_deduction_risk_premium.toFixed(4))
      this.check_total_insurance_premium = parseFloat(check_total_insurance_premium.toFixed(4))
      this.check_total_risk_premium = parseFloat(check_total_risk_premium.toFixed(4))
      this.check_total_premium = parseFloat((check_total_insurance_premium + check_total_risk_premium).toFixed(4))
    },
    handleSearch() {
      this.$refs.pagination.backNumOne()
    },
    handleDetailCreate() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择到账的业务清单')
        return
      }
      this.$refs.detail.handleCreate(this.multipleSelection)
    },
    handleUpdate(id, showDialogSave) {
      this.$refs.detail.handleUpdate(id, showDialogSave, this.apply_list)
    },
    handleCurrentChange(row) {
      this.currentRow = row
    },
    handleDelete(id){
      this.$confirm('是否确认删除该笔收入继续?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        deleteInsuranceFinanceDetail(id)
          .then(() => {
            this.loading = false
            this.$nextTick(() => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            setTimeout(() => {
              this.loadData()
            }, 1000)
            })
          })
          .catch(error => {
            this.loading = false
            this.$message.error(error)
          })
      }).catch((e) => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      });
    },
    handleConfirm() {
      if (this.is_diff) {
        if (!this.currentRow) {
          this.$message.error('实收金额与应收金额存在差额，请选择需要调整的业务清单');
        } else {
        this.$prompt('确认后将完成收款确认,完成后该对账文件将不允许修改以及删除, 是否继续?（实收金额与应收金额存在差额，请填写备注）', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          inputPlaceholder: '请输入不少于5个字的备注',
          inputValue: '',
          inputType: 'textarea',
          inputValidator: value => {
            if (value === '') {
              return '请填写备注'
            } else if (value.length < 5) {
              return '不少于5个字'
            } else {
              return true
            }
          },
        }).then(({ value }) => {
          this.confirm({'remark': value, 'apply_id': this.currentRow.id})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消到账确认'
          });
        });
        }
      } else {
        this.$confirm('确认后将完成收款确认,完成后该对账文件将不允许修改以及删除, 是否继续?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.confirm()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消到账确认'
          });
        });
      }
    },
    confirm(data) {
      this.loading = true
      confirmFinance(this.insurance_finance_id, data)
        .then(() => {
          this.loading = false
          this.$message.success('更新账单信息成功')
          this.$nextTick(() => {
            this.loadData()
          })
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
    },
  },
  beforeRouteLeave (to, from, next) {
        if (this.from_type == 'Collect' && to.name != 'CollectList') {
          window.localStorage.removeItem('query')
        }
        else if (this.from_type == 'Apply' && to.name != 'ApplyInsurance'){
          window.localStorage.removeItem('query')
        }
        next()
        },
  created() {
    // 入参处理
    if (this.$route.query.id === undefined){
      this.$router.push('/404')
    }
    this.insurance_finance_id = this.$route.query.id
    this.from_type = this.$route.query.from_type
    // 权限检查
    if (!this.$perm(["group_insurance.list_finance_detail"])) {
      this.$router.push('/401')
    }
    this.showView = true

    if (this.$perm(["group_insurance.create_finance_detail"])) {
      this.showAdd = true
    }

    if (this.$perm(["group_insurance.confirm_finance_detail"])) {
      this.showConfirm = true
    }

    if (this.$perm(["group_insurance.update_finance_detail"])) {
      this.showEdit = true
    }

    if (this.$perm(["group_insurance.delete_finance_detail"])) {
      this.showDelete = true
    }
    this.loadData()
  }
}
</script>